import React, { useState } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ApiSettings, init as initApi } from '@focaltec-suite/api'
import { FeedbackProvider } from '@focaltec-suite/commons'
import { defaultApiErrorTranslator } from '@focaltec-suite/core'
import { AppThemeProvider } from '@focaltec-suite/layouts'
import { AppContext } from './context/AppContext'
import SessionHolder from './context/SessionHolder'
import './App.css'

function App() {
    const [context] = useState({})
    const AppId = process.env.REACT_APP_APP_ID
    const ApiUrl = process.env.REACT_APP_API_URL

    initApi(
        new ApiSettings(
            AppId,
            ApiUrl,
            {
                secure: process.env.REACT_APP_COOKIE_SECURE === 'true',
                domain: process.env.REACT_APP_COOKIE_DOMAIN ?? '/',
                path: '/',
            },
            defaultApiErrorTranslator
        )
    )

    return (
        <BrowserRouter>
            <AppThemeProvider>
                <FeedbackProvider>
                    <AppContext.Provider value={context}>
                        <SessionHolder />
                    </AppContext.Provider>
                </FeedbackProvider>
            </AppThemeProvider>
        </BrowserRouter>
    )
}

export default App
